import React, { useEffect, useState } from "react";

export default function AdminClients() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/admin/clients.php")
      .then(res => res.json())
      .then(json => {
        if (json.ok) setRows(json.data || []);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-extrabold">العملاء</h2>
        <p className="text-sm text-slate-500">
          قائمة العملاء المحوّلين من طلبات التواصل
        </p>
      </div>

      <div className="bg-white border rounded-2xl overflow-x-auto">
        <table className="w-full text-sm min-w-[800px]">
          <thead className="bg-slate-50 text-slate-600">
            <tr>
              <th className="px-4 py-3 text-right">ID</th>
              <th className="px-4 py-3 text-right">البريد</th>
              <th className="px-4 py-3 text-right">الهاتف</th>
              <th className="px-4 py-3 text-right">ملاحظات</th>
              <th className="px-4 py-3 text-right">تاريخ الإنشاء</th>
            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr>
                <td colSpan="5" className="px-4 py-6 text-center text-slate-500">
                  جاري التحميل…
                </td>
              </tr>
            )}

            {!loading && rows.length === 0 && (
              <tr>
                <td colSpan="5" className="px-4 py-6 text-center text-slate-500">
                  لا يوجد عملاء
                </td>
              </tr>
            )}

            {rows.map(row => (
              <tr key={row.id} className="border-t">
                <td className="px-4 py-3">{row.id}</td>
                <td className="px-4 py-3 font-mono">{row.email || "-"}</td>
                <td className="px-4 py-3 font-mono">{row.phone || "-"}</td>
                <td className="px-4 py-3">{row.notes || "-"}</td>
                <td className="px-4 py-3 text-sm text-slate-500">
                  {row.created_at}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
